<template>
   <div id="app">
      <v-app>
         <v-navigation-drawer
            app
            v-model="drawer"
            temporary
            width="300"
            :bottom="!$vuetify.breakpoint.mdAndUp"
         >
            <v-card height="12vh" flat tile>
               <v-card-title :class="`${this.$globalstore.schoolcolor}`">
                  {{ $globalstore.user.username }}
               </v-card-title>
               <v-card-subtitle :class="`${this.$globalstore.schoolcolor}`">
                  {{ $globalstore.user.rolename }}
               </v-card-subtitle>
               <v-card height="84vh" flat class="overflow-y-auto">
                  <v-list dense>
                     <v-list-item-group active-class="menuselect">
                        <v-list-item
                           v-for="(menu, i) in $globalstore.user.userMenu"
                           :key="i"
                           link
                           :to="menu.route ? menu.route : null"
                        >
                           <v-list-item-icon>
                              <v-icon :color="menu.color">{{ menu.icon }}</v-icon>
                           </v-list-item-icon>
                           <v-list-item-content>
                              <v-list-item-title>{{ menu.text }}</v-list-item-title>
                           </v-list-item-content>
                        </v-list-item>
                     </v-list-item-group>
                  </v-list>
               </v-card>
            </v-card>
         </v-navigation-drawer>
         <v-app-bar app>
            <v-app-bar-nav-icon
               v-show="UserLoggedIn"
               @click="drawer = !drawer"
               :class="{'pa-0': $vuetify.breakpoint.xs}"
            ></v-app-bar-nav-icon>
            <v-toolbar-title :class="{'subtitle-2 pa-1': $vuetify.breakpoint.xs}">
               <router-link :to="{name: 'Home'}" class="text-decoration-none black--text">
                  <span>HELP International School</span>
                  <p v-if="$vuetify.breakpoint.mdAndUp" class="subtitle-2">
                     <!-- Co-Curricular Activity Portal -->
                     {{ applongname }}
                  </p>
                  <p v-else class="subtitle-2">
                     <!-- CCA Portal -->
                     {{ appshortname }}
                  </p>
               </router-link>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <div v-if="UserLoggedIn">
               <v-btn
                  v-if="UserCanChangePassword"
                  color="primary"
                  class="mr-2"
                  @click="changePassword"
               >
                  <template v-if="$vuetify.breakpoint.mdAndUp">
                     Change Password
                  </template>
                  <template v-else>
                     <v-icon>lock</v-icon>
                  </template>
               </v-btn>
               <v-btn class="red darken-3 white--text" @click="LogOut">
                  <template v-if="$vuetify.breakpoint.mdAndUp">Sign Out </template>
                  <v-icon right>mdi-logout</v-icon>
               </v-btn>
            </div>
         </v-app-bar>

         <!-- This is the main location for all router links -->
         <v-main>
            <router-view />
         </v-main>
      </v-app>
      <confirm-dlg ref="confirm"></confirm-dlg>
   </div>
</template>

<script>
   import ConfirmDlg from "@/components/ConfirmDlg.vue";
   import GlobalConstant from "@/common/globalconstant.js";
   import {UserType} from "@/common/constant.js";

   export default {
      components: {ConfirmDlg},
      name: "App",

      data() {
         return {
            drawer: null,
            server_datetime: null,
            applongname: GlobalConstant.APP_LONGNAME,
            appshortname: GlobalConstant.APP_SHORTNAME,
         };
      },
      computed: {
         UserLoggedIn() {
            return this.$globalstore.user.isLoggedIn;
         },

         UserCanChangePassword() {
            return (
               this.$globalstore.user.isLoggedIn &&
               this.$globalstore.user.usertype === UserType.VENDOR
            );
         },
      },

      watch: {
         "$globalstore.user.tokenexpired": function(newval, oldval) {
            if (newval) {
               this.$refs.confirm
                  .open("Information", "Session has expired. Please login again", {
                     color: "primary",
                     noconfirm: true,
                  })
                  .then((reply) => {
                     this.LogOut();
                  });
            }
         },
      },

      provide() {
         return {
            ShowMessage: this.ShowMsg,
            ServerDateTime: this.GetServerDateTime,
         };
      },

      methods: {
         changePassword() {
            //
         },

         async CheckUserToken(token) {
            await this.$http({
               url: "/common/userToken.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {usertoken: token, source: "app"},
               method: "POST",
            }).then((response) => {
               if (response.data.tokenexpired) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     // this.ShowMsg({
                     //    title: "Error",
                     //    message: response.data.message,
                     //    color: "red",
                     // });
                     this.LogOut();
                  } else {
                     this.$globalstore.user.usertoken = token;
                     this.$globalstore.user.tokenexpired = false;
                     this.$globalstore.user.userid = response.data.userdata.id;
                     this.$globalstore.user.useremail = response.data.userdata.email;
                     this.$globalstore.user.usertype = response.data.userdata.usertype;
                     this.$globalstore.user.username = response.data.userdata.username;
                     this.$globalstore.user.userlinkid = response.data.userdata.userlinkid;
                     if (response.data.userdata.userroles) {
                        this.$globalstore.user.userroles = response.data.userdata.userroles;
                        const roles = response.data.userdata.userroles;
                        if (roles.length > 0) {
                           const role = roles[0];
                           this.$globalstore.user.rolename = role["role_description"];
                        }
                     }
                     // Save user caplist
                     if (response.data.userdata.usercap) {
                        this.$globalstore.user.usercap = response.data.userdata.usercap;
                     }
                     this.$globalstore.BuildMenu();
                     this.$globalstore.user.isLoggedIn = true;
                     this.$globalstore.user.tokenexpired = false;
                     this.$globalstore.appready = true;
                     this.$router.push({name: "Home"});
                  }
               }
            });
         },

         ShowMsg(msgdata) {
            this.$refs.confirm
               .open(msgdata.title, msgdata.message, {
                  color: msgdata.color,
                  noconfirm: true,
               })
               .then((reply) => {});
         },

         async GetServerDateTime() {
            await this.doGetServerDateTime();
            return this.server_datetime;
         },

         async doGetServerDateTime() {
            await this.$http({
               url: "/common/getsystemdatetime.php",
               method: "GET",
            }).then((response) => {
               this.server_datetime = response.data;
            });
         },

         async LogOut() {
            const utype = this.$globalstore.user.usertype;

            await this.$globalstore.LogOutAndResetUser();
            if (utype === UserType.PARENT || utype === UserType.STUDENT) {
               this.$router.push({name: "StaticSignOut"});
            } else {
               this.$router.push({name: "Login"});
            }
         },

         async AppSettings() {
            await this.$http({
               url: "/common/getappsettings.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {section: "CCA"},
               method: "POST",
            }).then((response) => {
               if (response.data.error) {
                  this.ShowMsg({
                     title: "Fatal Error",
                     message: "Unable to read application settings.",
                     color: "red",
                  });
               } else {
                  this.$globalstore.appsettings = response.data.appsettings;
                  console.log(this.$globalstore.appsettings);
               }
            });
         },
      },

      mounted: async function() {
         await this.AppSettings();

         var token = localStorage.getItem("usertoken");

         if (token) {
            await this.CheckUserToken(token);
         } else {
            this.$globalstore.appready = true;
            this.$router.push({name: "Login"});
         }
      },

      // beforeDestroy() {
      //    localStorage.removeItem("usertoken");
      // },
   };
</script>

<style>
   .menuselect {
      background: #e57373 !important;
      color: white !important;
   }

   tr.v-data-table__selected {
      /* background: #7d92f5 !important; */
      background: #ffcdd2 !important;
   }

   .needattention {
      color: red;
   }
</style>
